































































































import { IBudget } from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";

@Component
export default class DataIntegrator extends Vue {
  @Getter("getBudget", { namespace: "coupon" }) budget!: IBudget;
  @Getter("getCodeCoupon", { namespace: "coupon" }) codeCoupon!: string;
}
